module.exports = __webpack_public_path__ + "static/media/icon04.ce9e8a62.svg";